import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import crypto from "crypto-js";
import "../../App.css";
import "./Maincontent.css";
import JobConfirmation from "../JoborderList/JobConfirmation";

const MainContent = () => {
    // Audio playback event handlers
    const handleTimeUpdate = () => {};
    const handlePause = () => {
      setIsRecordingPlayed(false);
    };
    const handlePlay = () => {
      setIsRecordingPlayed(true);
    };
    const handleEnded = () => {
  setIsRecordingPlayed(false);
};
  const [formData, setFormData] = useState({
    FirstName: "",
    LastName: "",
    Email: "",
    phoneNumber: "",
    countryCode: "US",
    JobId: "",
    AccountId: "",
    Company: "",
    IsCandidateAgreedWithTermCondition: false,
  });
  const [jobOrders, setJobOrders] = useState([]);
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isRecordingPlayed, setIsRecordingPlayed] = useState(false);
  const audioRef = useRef(null);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showSuccess2, setShowSuccess2] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  // const [IsTableStorageCalled, setIsTableStorageCalled] = useRef(false);
  const [submissionStatus, setSubmissionStatus] = useState({
    isSubmitting: false,
    isSuccess: false,
    errorMessage: "",
  });
  const isFetchJobsCalled = useRef(false);

  // const tableStorageConfig = {
  //     name: 'psgsprintstorage',
  //     key: 'nZl6apVUMnB0BlNgy+RwCzSpqWNSeTRi2wockEsjUH0OmDlvw0DtmGJJk3d36H//PkVo1wRvU7EaI+vCl6JeHg=='
  // };

  const tableStorageConfig = {
    name: "psgprodreportstorage",
    key: "fW9wr6U/wdBy6xjXT3ZKLkpGG/WQXEbZg4pwmMKOLjK1gQuivy5uXDYrvxvss0PVy3Mk2rZQ7iD49rwPNHr8Lw==",
  };

  const generateSignature = (canonicalString) => {
    return crypto.enc.Base64.stringify(
      crypto.HmacSHA256(
        canonicalString,
        crypto.enc.Base64.parse(tableStorageConfig.key)
      )
    );
  };

  const generateHeaders = (UTCDate, signature) => {
    return {
      Authorization: `SharedKeyLite ${tableStorageConfig.name}:${signature}`,
      Accept: "application/json;odata=nometadata",
      "x-ms-date": UTCDate,
      "x-ms-version": "2015-04-05",
    };
  };

  const fetchJobs = async () => {
    if (isFetchJobsCalled.current) {
      return;
    }

    isFetchJobsCalled.current = true; // Mark as called
    setLoading(true);
    try {
      const UTCDate = new Date().toUTCString();
      const tableName = "AnnaDemoJoDetails";
      const signature = generateSignature(
        `${UTCDate}\n/${tableStorageConfig.name}/${tableName}`
      );

      const { data } = await axios.get(
        `https://${tableStorageConfig.name}.table.core.windows.net/${tableName}`,
        { headers: generateHeaders(UTCDate, signature) }
      );

      const filteredData = data.value.filter((item) => item.SiteName === "TP");
      setJobOrders(filteredData);
      fetchCountryCode();
    } catch (error) {
      alert("Error loading job positions");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJobs();
  }, []);

  const fetchCountryCode = async () =>{
    try {
      const UTCDate = new Date().toUTCString();
      const tableName = "AnnaDemoCountryCode";
      const signature = generateSignature(
        `${UTCDate}\n/${tableStorageConfig.name}/${tableName}`
      );

      const { data } = await axios.get(
        `https://${tableStorageConfig.name}.table.core.windows.net/${tableName}`,
        { headers: generateHeaders(UTCDate, signature) }
      );

      const filteredData = data?.value || [];
      setCountries(filteredData);
    } catch (error) {
      alert("Error loading countries and codes");
    }
  };

  const getJobOrderId = () => {
    if (formData.JobId && formData.JobId.length > 0) {
      return parseInt(formData.JobId, 10);
    } else {
      return filteredJobOrders[0]?.PartitionKey;
    }
  };

  const getAccountId = () => {
    if (formData.AccountId && formData.AccountId.length > 0) {
      return parseInt(formData.AccountId, 10);
    } else {
      return filteredJobOrders[0]?.RowKey;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const selectedCountry = countries.find(
      (c) => c.CountryAbbr === formData.countryCode
    );
    let phoneNumber1;
    // if (formData.countryCode === "PH") {
      phoneNumber1 = formData.phoneNumber;
    // } else {
    //   phoneNumber1 = selectedCountry.CountryCode + formData.phoneNumber;
    // }
    let email = formData.Email.trim();
    if (!email) {
      const cleanFirstName = formData.FirstName.replace(
        /\s+/g,
        ""
      ).toLowerCase();
      const cleanLastName = formData.LastName.replace(/\s+/g, "").toLowerCase();
      const randomFourDigit = Math.floor(1000 + Math.random() * 9000); // Generate a random 4-digit number
      email = `${cleanFirstName}${cleanLastName}${randomFourDigit}@noemail.com`;
    }

    const payload = {
      FirstName: formData.FirstName,
      LastName: formData.LastName,
      Email: email,
      PhoneNumber: phoneNumber1,
      JobOrderId: getJobOrderId(),
      AccountId: getAccountId(),
      Country: formData.countryCode,
      State: selectedCountry.DefaultState,
      City: selectedCountry.DefaultCity,
      AddedFrom: "WalkinCandidate",
      Source : "Tradeshow",
      IsCandidateAgreedWithTermCondition:
      formData.IsCandidateAgreedWithTermCondition,
    };

    try {
          // const response = await axios.post(
          //     'https://psgsprintapiservice.azurewebsites.net/WebApi/RegisterInboundCandidate',
          //     payload,
          //     {
          //         headers: {
          //             Authorization: 'Basic',
          //             APPID: '77527983-C49A-4214-8FA5-3F9D6FEDDFE4',
          //             APPKey: 'YZtY1RuABSN26iDu/gXa/T6JokZlywuIN8JBklycX5s=',
          //             'Content-Type': 'application/json'
          //         }
          //     }
          // );

          // "https://psgindeedprodapiservice.azurewebsites.net/WebApi/RegisterInboundCandidate",
      const response = await axios.post(
        "https://psgdigitalrecruiterprodapiservice.azurewebsites.net/RegisterWalkInCandidate",
        payload,
        {
          headers: {
            Authorization: "Basic",
            APPID: "59C80CF6-471C-414E-9D54-777A1B863B54",
            APPKey: "qjcHgRz0wxxlhktj1/PKr1g0qn19G/ouDmmC0h0Dz6o=",
            "Content-Type": "application/json",
          },
        }
      );

      if ( response.status === 200 || response.status === 201) {
        getJobOrderTitleAndDescription(
          formData.JobId || filteredJobOrders[0]?.PartitionKey
        );
        setFormData({
          FirstName: "",
          LastName: "",
          Email: "",
          PhoneNumber1: "",
          JobId: "",
          AccountId: "",
          Company: "",
          IsCandidateAgreedWithTermCondition: false,
        });
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 5000);
        setShowSuccess2(true);
        scrollToTop();
        setSubmissionStatus({
          isSubmitting: false,
          isSuccess: true,
          errorMessage: "",
        });

        setTimeout(() => {
          setSubmissionStatus((prev) => ({ ...prev, isSuccess: false }));
        }, 5000);
      }
    } catch (error) {
      alert(error.response?.data?.Message || "Error submitting form");
    } finally {
      setIsSubmitting(false);
    }
  };

  const filteredJobOrders = jobOrders;
  // .filter(job =>
  //     job.Country === formData.countryCode
  // );
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "countryCode") {
      setFormData((prev) => ({
        ...prev,
        countryCode: value,
        phoneNumber: "",
        JobId: "",
        AccountId: "",
      }));
    } else if (name === "phoneNumber") {
      const cleaned = value.replace(/\D/g, "");
      const selectedCountry = countries.find(
        (c) => c.code === formData.countryCode
      );
      const maxLength = 13;
      const truncated = cleaned.slice(0, maxLength);
      setFormData((prev) => ({
        ...prev,
        phoneNumber: truncated,
      }));
    } else if (name === "JobId") {
      const selectedJob = jobOrders.find((job) => job.PartitionKey === value);
      setFormData((prev) => ({
        ...prev,
        JobId: value,
        AccountId: selectedJob ? selectedJob.RowKey : "",
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const getJobOrderTitleAndDescription = (selectedJobOrderId) => {
    const job = jobOrders.find(
      (job) => job.PartitionKey === selectedJobOrderId
    );
    if (job) {
      setSelectedJob(job);
    } else {
      setSelectedJob("");
    }
  };

const playPauseRecording = () => {
  if (!isRecordingPlayed) {
    setIsRecordingPlayed(true);
    if (audioRef.current) {
      // Only reset to start if audio is at the end
      if (audioRef.current.currentTime === audioRef.current.duration) {
        audioRef.current.currentTime = 0;
      }
      audioRef.current.play();
    }
  } else {
    setIsRecordingPlayed(false);
    if (audioRef.current) {
      audioRef.current.pause();
      // Do not reset currentTime, so resume works
    }
  }
}; 


  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <section
      className={`ebook-template-container ${showSuccess2 ? "pt-20px" : ""}`}
      id="ebook"
    >
      {showSuccess && (
        <div className="success-message">
          <p>
            Your information has been saved successfully. You will hear from us
            shortly.
          </p>
          <button onClick={() => setShowSuccess(false)}>×</button>
        </div>
      )}

      {!showSuccess2 && (
        <div className="ebook-template-box">
          <div className="ebook-template-sub-box">
            <div className="ebook-template-tech-box">
              <h3 className="ebook-template-title SancoaleBold">
                Meet our AI-powered recruiter, Anna AI
              </h3>
              <p className="no-margin-top fw-normal">
                Anna AI is your AI recruiter—powered by a large language model
                able to understand people, speaks naturally, and adapts to every
                candidate for conversations. She handles phone interviews based
                on job requirements, keeps candidates engaged throughout
                the hiring journey, and is ready to connect with as many
                candidates as needed, anytime, day or night.
              </p>
              <div className="ebook-strong SancoaleRegular fs-28">
                Try a Real TP Interview with Anna
              </div>
              <p className="no-margin-top fw-normal">
                This is more than a simulation—it’s a live, interactive demo
                using real job data from our TP expert position in Richmond,
                Virginia.
              </p>
              <div className="ebook-strong SancoaleRegular fs-28">
                What to Expect in the Demo
              </div>
              <p className="no-margin-top fw-normal">
                Anna will call you and guide you through a series of interview
                questions based on an TP job role.
              </p>
              <p className="fs-21 fw-normal">You’ll be asked about your:</p>
              <ul className="additional-text-styling fw-normal">
                <li>
                    Customer service experience
                </li>
                <li>
                    Ability to multitask and prioritize under pressure
                </li>
                <li>
                    Typing speed and communication skills
                </li>
                <li>
                    Availability and willingness to work on-site in Richmond, Virginia
                </li>
              </ul>

              <p className="fw-normal">
                The call feels natural —because it is. Anna uses advanced AI to understand your responses in real time.
              </p>
            </div>

            <form onSubmit={handleSubmit} className="form-styles">
              <div>
                <h2 className="ebook-image-url"></h2>
                {/* <h2 className="text-2xl font-semibold mb-4">
                  Ready to Try?
                </h2>
                <p className="mb-6">
                  Fill the form below and experience your
                  <strong> first interview with Anna AI.</strong>
                </p> */}
              </div>
              <input
                type="text"
                name="FirstName"
                value={formData.FirstName}
                onChange={handleChange}
                required
                placeholder="First Name*"
              />

              <input
                type="text"
                name="LastName"
                value={formData.LastName}
                onChange={handleChange}
                required
                placeholder="Last Name*"
              />

              <div className="form-field-with-label">
                {/* Phone Number Section */}
                <div className="maincontent-phone-field">
                  <label className="maincontent-phone-label">
                    Phone Number *
                  </label>
                  <div className="maincontent-phone-input-group">
                    <select
                      className="maincontent-country-select"
                      name="countryCode"
                      value={formData.countryCode}
                      onChange={handleChange}
                      required
                    >
                      {countries.map((country) => (
                        <option key={country.CountryAbbr} value={country.CountryAbbr}>
                          {country.CountryAbbr} ({country.CountryCode})
                        </option>
                      ))}
                    </select>
                    <input
                      className="maincontent-phone-input"
                      type="tel"
                      name="phoneNumber"
                      value={formData.phoneNumber}
                      onChange={handleChange}
                      required
                      placeholder="1234567890"
                      title="Please enter your phone number"
                    />
                  </div>
                </div>
              </div>

            {filteredJobOrders.length > 1 ? (
              <div className="form-field-with-label">
                <label className="left-aligned-label">Job *</label>
                <div className="maincontent-job-select w-100">
                  <select
                    className="m-0"
                    name="JobId"
                    value={formData.JobId}
                    onChange={handleChange}
                    required
                    disabled={loading}
                  >
                    <option value="" disabled className="pr-2">
                      Select Job *
                    </option>
                    {filteredJobOrders.map((job) => (
                      <option key={job.PartitionKey} value={job.PartitionKey}>
                        {job.JobSubName}
                      </option>
                    ))}
                  </select>
                  {loading && <p className="loading-text">Loading job...</p>}
                </div>
              </div>
            ) : null}

              {/* <div className="checkbox-container">
                <input
                  type="checkbox"
                  id="opt"
                  name="IsCandidateAgreedWithTermCondition"
                  checked={formData.IsCandidateAgreedWithTermCondition}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      IsCandidateAgreedWithTermCondition: e.target.checked,
                    }))
                  }
                  // Hide audio player, control playback
                  required
                />
                <label htmlFor="opt" className="checkbox-label">
                  I agree to terms and conditions*
                </label>
              </div> */}
                <div className="mb-2">
                <small>By clicking submit below, you grant permission to securely store and process this form, in order to provide you with the requested support/content.</small>
              </div>
              <button type="submit" disabled={isSubmitting}>
                {isSubmitting ? "Submitting..." : "REQUEST DEMO"}
              </button>
              <div className="mt-1-25">
                <h3 className="no-margin-top noto-sans-regular fw-normal ebook-template-title-recorded-audio custom-ebook-title">
                  Don't have time to run the demo call?
                </h3>
                <h3 className="noto-sans-regular ebook-template-title-recorded-audio">
                  You may listen to a prerecorded interview call with Anna AI by clicking below
                </h3>
                <button
                  type="button"
                  onClick={playPauseRecording}
                  className={isRecordingPlayed ? "recording-playing" : ""}
                >
                  {isRecordingPlayed ? "Click to pause recording" : "Listen to recorded demo"}
                </button>

                <audio
                  style={{ display: "none" }}
                  ref={audioRef}
                  controls
                  onTimeUpdate={handleTimeUpdate}
                  onPause={handlePause}
                  onPlay={handlePlay}
                  onEnded={handleEnded}
                >
                <source src={"../../../../anna-ai-tp-demo/audio/David-TP-Demo-08-12.wav"} type="audio/mpeg" />
                Your browser does not support the audio element.
              </audio>
              </div>
              
            </form>
          </div>
        </div>
      )}

      {showSuccess2 && (
        <JobConfirmation
          jobTitle={selectedJob.JobTitle}
          jobDescription={selectedJob.JobDescription}
          company={selectedJob.Company}
          location={selectedJob.Location}
          job={selectedJob}
          schedule = {selectedJob.Schedule}
          channels = {selectedJob.Channels}
          requirements = {selectedJob.Requirements}
          note = {selectedJob.Note}
        />
      )}
    </section>
  );
};

export default MainContent;
